(() => {
  const root = document.querySelector('[data-keli-signup]');
  if (!root) return;

  const DISMISS_KEY = 'keli-signup-dismissed';
  const DONE_KEY = 'keli-signup-done';
  const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;

  const now = () => Date.now();
  const dismissedRecently = () => {
    if (localStorage.getItem(DONE_KEY)) return true;
    const ts = Number(localStorage.getItem(DISMISS_KEY) || 0);
    return ts && now() - ts < THIRTY_DAYS;
  };

  const formView = root.querySelector('.keli-signup__view--form');
  const successView = root.querySelector('.keli-signup__view--success');
  const form = root.querySelector('.keli-signup__form');
  const errorEl = root.querySelector('.keli-signup__error');
  let opened = false;

  // Non-modal floating card: the page stays scrollable and interactive, so there is no
  // body scroll lock and no focus trap. Escape and the close button dismiss it.
  const onKeydown = (e) => { if (e.key === 'Escape') dismiss(); };

  const open = () => {
    if (opened || dismissedRecently()) return;
    opened = true;
    root.hidden = false;
    document.addEventListener('keydown', onKeydown);
    if (window.matchMedia('(min-width: 750px)').matches) {
      root.querySelector('.keli-signup__field')?.focus?.();
    }
  };

  const close = () => {
    root.hidden = true;
    document.removeEventListener('keydown', onKeydown);
  };

  const dismiss = () => {
    if (!localStorage.getItem(DONE_KEY)) localStorage.setItem(DISMISS_KEY, String(now()));
    close();
  };

  root.querySelectorAll('[data-keli-signup-dismiss]').forEach((el) => el.addEventListener('click', dismiss));

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errorEl.hidden = true;
    const email = form.email.value.trim();
    if (!email) return;
    const submit = form.querySelector('.keli-signup__submit');
    submit.disabled = true;
    try {
      const res = await fetch(
        `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(root.dataset.companyId)}`,
        {
          method: 'POST',
          headers: { revision: '2026-04-15', 'content-type': 'application/vnd.api+json' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Welcome signup popup',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email,
                      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                    },
                  },
                },
              },
              relationships: { list: { data: { type: 'list', id: root.dataset.listId } } },
            },
          }),
        }
      );
      if (res.status !== 202) throw new Error(`Klaviyo ${res.status}`);
      localStorage.setItem(DONE_KEY, '1');
      formView.hidden = true;
      successView.hidden = false;
    } catch (err) {
      errorEl.hidden = false;
      submit.disabled = false;
    }
  });

  // Trigger: whichever comes first — delay OR 20% scroll depth.
  if (!dismissedRecently()) {
    const delay = Number(root.dataset.delay) || 8000;
    const timer = setTimeout(open, delay);
    const onScroll = () => {
      const depth = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
      if (depth >= (Number(root.dataset.scroll) || 20) / 100) {
        clearTimeout(timer);
        open();
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
